'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalAtm = function MdLocalAtm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 30v-20h-26.8v20h26.8z m0-23.4c1.8 0 3.2 1.5 3.2 3.4v20c0 1.9-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.5-3.2-3.4v-20c0-1.9 1.4-3.4 3.2-3.4h26.8z m-15 21.8v-1.8h-3.4v-3.2h6.6v-1.8h-5c-0.9 0-1.6-0.7-1.6-1.6v-5c0-0.9 0.7-1.6 1.6-1.6h1.8v-1.8h3.2v1.8h3.4v3.2h-6.6v1.8h5c0.9 0 1.6 0.7 1.6 1.6v5c0 0.9-0.7 1.6-1.6 1.6h-1.8v1.8h-3.2z' })
        )
    );
};

exports.default = MdLocalAtm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-atm.js
// module id = 3041
// module chunks = 0